<p-tabView *ngIf="formLogging; else mainTemplate">
  <p-tabPanel header="Create trigger">
    <ng-template pTemplate="content">
      <ng-container [ngTemplateOutlet]="mainTemplate"></ng-container>
    </ng-template>
  </p-tabPanel>
  <p-tabPanel header="Logging">
    <ng-template pTemplate="content">
      <selfai-platform-logging [form]="formLogging"></selfai-platform-logging>
    </ng-template>
  </p-tabPanel>
</p-tabView>

<ng-template #mainTemplate>
  <ng-container *ngIf="!dataIsEmpty; else workflowEmptyData">
    <form class="flex flex-wrap" [formGroup]="form">
      <div class="field mb-3 mr-3">
        <label class="mr-2" for="result-column">Result column</label>
        <input class="w-20rem" id="result-column" type="text" formControlName="resultColumn" pInputText />
      </div>
      <div class="field-checkbox mb-3 mr-3">
        <p-checkbox name="input" [binary]="true" formControlName="debugMode" inputId="debug-mode"></p-checkbox>
        <label for="debug-mode">Debug mode</label>
      </div>
      <div class="field-checkbox mb-3">
        <p-checkbox name="input" [binary]="true" formControlName="conditionOptimizationDisabled" inputId="condition-optimization-disabled"></p-checkbox>
        <label for="condition-optimization-disabled">Disable Optimized mode</label>
      </div>
    </form>

    <p-table
      #tableRef
      [selfaiPlatformCellSizing]="sizingTableName"
      class="table"
      dataKey="controls.id.value"
      [resizableColumns]="true"
      responsiveLayout="scroll"
      styleClass="p-datatable-gridlines"
      [value]="items"
      [globalFilterFields]="['controls.attrColumnName.value', 'controls.resultColumn.value']"
      (onRowReorder)="items = tableRef.value"
    >
      <ng-template pTemplate="caption">
        <div class="flex">
          <span class="p-input-icon-left">
            <i class="pi pi-search"></i>
            <input pInputText type="text" (input)="filter($event)" placeholder="Search" />
          </span>
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr #tableColRef>
          <th style="width: 3rem"></th>
          <th pResizableColumn>Attribute</th>
          <th pResizableColumn>Condition</th>
          <th pResizableColumn>Value</th>
          <th pResizableColumn>Primary</th>
          <th pResizableColumn>Result column (optional)</th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item let-expanded="expanded" let-index="rowIndex">
        <tr [pReorderableRow]="index">
          <td>
            <span class="pi pi-bars" pReorderableRowHandle></span>
          </td>
          <td [pRowToggler]="item">
            {{ item.controls.attrColumnName.value }}
          </td>
          <td [pRowToggler]="item">
            {{ item.controls.condition.value }}
          </td>
          <td class="max-w-10rem text-ellipsis" [pRowToggler]="item">
            {{ item.controls.value?.value }}
          </td>
          <td>
            <p-checkbox [formControl]="item.controls.primaryClone" name="input" [binary]="true"></p-checkbox>
          </td>
          <td [pRowToggler]="item">
            {{ item.controls.resultColumn.value }}
          </td>
          <td>
            <button
              type="button"
              pButton
              class="p-button-text p-button-link p-button-danger p-0"
              appearance="icon"
              (click)="removeItem(item.controls.id.value)"
              icon="pi pi-trash"
              pTooltip="Remove"
            ></button>
            <button
              type="button"
              pButton
              class="p-button-text p-button-link p-0"
              appearance="icon"
              (click)="copyItem(item.controls.id.value)"
              icon="pi pi-copy"
              pTooltip="Copy"
            ></button>
            <button
              type="button"
              pButton
              class="p-button-text p-button-link p-0"
              appearance="icon"
              [icon]="expanded ? 'pi pi-times' : 'pi pi-pencil'"
              [pTooltip]="expanded ? 'Close condition' : 'Edit condition'"
              [pRowToggler]="item"
            ></button>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="rowexpansion" let-item>
        <tr>
          <td colspan="6">
            <div [@rowExpansionTrigger]="'active'">
              <selfai-platform-condition [conditionItems]="conditions" [form]="item"></selfai-platform-condition>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="6">No data</td>
        </tr>
      </ng-template>
    </p-table>

    <button
      label="add group"
      pButton
      pRipple
      icon="pi pi-plus"
      type="button"
      class="mr-3 mt-3 p-button-sm"
      (click)="addItem()"
    ></button>
  </ng-container>
</ng-template>

<ng-template #workflowEmptyData>
  <p-messages severity="error">
    <ng-template pTemplate>Data of workflow isn't available yet. Try again later</ng-template>
  </p-messages>
</ng-template>
